module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "about"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _c('div', [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v("About The Team"), _c('hr'), _c('span', {
    staticClass: "f3"
  }, [_vm._v("behind Dreaming of a Jewish Christmas")])]), _vm._l((_vm.page.page_containers), function(p) {
    return _c('div', {
      staticClass: "containerabout flex"
    }, [_c('div', {
      staticClass: "imageabout"
    }, [(p.container.medias.length > 0) ? _c('img', {
      staticClass: "fl",
      attrs: {
        "src": p.container.medias[0].image.url
      }
    }) : _vm._e(), _c('div', {
      staticClass: "soustitreimageabout fl"
    }, [_vm._v(_vm._s(p.container.titre))])]), _c('div', {
      staticClass: "contenuabout"
    }, [_c('div', {
      staticClass: "fr",
      domProps: {
        "innerHTML": _vm._s(p.container.description)
      }
    })])])
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36ce5d55","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film/About.vue
// module id = 1279
// module chunks = 1